export default __webpack_public_path__ + "static/media/MP0069.17cd22c5.jpg";